import Vue from "vue";
import { mapActions } from "vuex";
import WhoDoYouKnow from "WhoDoYouKnowComponents/WhoDoYouKnow";
import router from "JS/routers/whodoyouknow/routes";
import store from "Stores/modules/campaign/store.whodoyouknow";
import { cloneDeep as _cloneDeep } from "lodash";

const VM = new Vue({
  el: "#p2a-campaign-container",
  router,
  store,
  components: {
    WhoDoYouKnow
  },
  data() {
    const {
      campaign: appSettings,
      campaignSettings,
      customerSettings
    } = _cloneDeep(window.P2A);

    return {
      appSettings,
      campaignSettings,
      customerSettings
    };
  },
  created() {
    this.setStateFromSettings(this.campaignSettings);
  },
  methods: {
    ...mapActions({
      setStateFromSettings: "campaign/fromSettings"
    })
  }
});
